import React from "react";
import "../styles/Footer.css";
import { Twitter, GitHub, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer_start">
        {" "}
        <h3>
          Have any Questions?
          <br /> Reach out
        </h3>
        <p>
          Send me a <span>tweet</span> or email me at: <br />
          <span>kulkarnikeyur.g@gmail.com</span>
        </p>
      </div>

      <div className="footer_close">
        <div>
          <a href="https://www.linkedin.com/in/keyur-g-kulkarni-273072237">
            {" "}
            <LinkedIn />
          </a>
          <a href="https://github.com/KeyurGK">
            <GitHub />
          </a>

          <a href="https://twitter.com/keyurGK">
            {" "}
            <Twitter />
          </a>
        </div>
        <p>
          Copyright &copy; 2021-2023 Keyur G Kulkarni <br /> All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
